// Monaco Editor worker configuration
// This file sets up web workers for Monaco Editor to handle language services

// @ts-ignore
import EditorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker';
// @ts-ignore
import JsonWorker from 'monaco-editor/esm/vs/language/json/json.worker?worker';

// Only import the workers you actually need
// DO NOT import ts.worker unless you need TypeScript IntelliSense (7MB+)
// @ts-ignore
// import TsWorker from 'monaco-editor/esm/vs/language/typescript/ts.worker?worker';

export function setupMonacoWorkers() {
  (self as any).MonacoEnvironment = {
    getWorker(_: any, label: string) {
      if (label === 'json') {
        return new JsonWorker();
      }

      // For any other language including typescript/javascript,
      // use the base editor worker (no IntelliSense but much smaller)
      return new EditorWorker();
    },
  };
}
